export const faq = {
  title: '常见问题',
  subtitle: '查找有关MakanTak的常见问题答案',
  backToHome: '返回首页',
  stillHaveQuestions: '还有问题？',
  stillHaveQuestionsDesc: '找不到您要找的答案？我们的支持团队随时为您服务！',
  contactSupport: '联系支持',
  
  q1: '什么是MakanTak？',
  a1: 'MakanTak是一个推荐奖励平台，让您通过分享赚取优惠。当您推荐朋友消费时，您将获得虚拟货币，可在下次用餐时抵扣！',
  
  q2: '如何赚取虚拟货币？',
  a2Title: '您可以通过两种方式赚取虚拟货币：',
  a2Point1: '首次购买保证5%折扣',
  a2Point2: '您推荐的人每次购买的1%（最多3级）',
  a2Example: '例如：如果您的朋友消费RM100，您赚取RM1。如果他们的朋友消费RM100，您也赚取RM1！',
  
  q3: '如何分享我的推荐码？',
  a3: '转到您的仪表板并点击"分享"按钮。您可以通过WhatsApp、Facebook或任何消息应用分享您的唯一二维码或链接。当有人使用您的链接注册时，他们就成为您的下线！',
  
  q4: '我可以使用的最大折扣是多少？',
  a4: '您可以使用虚拟货币兑换账单金额的最多20%。例如，在RM100的账单上，您最多可以使用RM20的虚拟货币余额。',
  
  q5: '我的虚拟货币会过期吗？',
  a5: '是的，虚拟货币在您赚取后30天过期。您将在到期前7天收到电子邮件通知提醒您使用它。请务必定期检查您的余额！',
  
  q6: '我可以组合折扣吗？',
  a6: '可以！您的首次5%保证折扣会自动应用，您还可以在此基础上兑换虚拟货币（最多账单的20%）。',
  
  q7: '我可以从多少级推荐中赚取？',
  a7: '您可以从最多3级推荐中赚取。第1级是您直接推荐的人，第2级是他们推荐的人，第3级是第2级推荐的人。每一级都为您赚取其购买的1%。',
  
  q8: '如何兑换我的虚拟货币？',
  a8: '付款时只需向工作人员出示您的二维码。他们会扫描，您可以选择兑换多少虚拟货币（最多账单的20%）。折扣立即应用！',
  
  q9: '我的个人数据安全吗？',
  a9: '是的！我们遵守马来西亚2010年个人数据保护法（PDPA）。我们只收集必要的信息，未经同意不会与第三方共享您的数据。',
  a9Link: '阅读我们的完整隐私政策了解详情。',
  
  q10: '我可以在任何餐厅使用我的虚拟货币吗？',
  a10: '目前，虚拟货币特定于您赚取它的餐厅。每家餐厅都有自己的推荐计划。',
  
  q11: '如果我忘记密码怎么办？',
  a11: '在登录页面点击"忘记密码"。我们会通过电子邮件向您发送密码重置链接。按照链接创建新密码。',
  
  q12: '我可以更改我的生日或电子邮件吗？',
  a12: '出于安全原因，生日和电子邮件无法直接更改。如果您需要更新这些详细信息，请联系我们的支持团队。',
  
  q13: '为什么我需要提供我的生日？',
  a13: '我们需要您的生日来验证您年满18岁（法定年龄要求）并向您发送特别的生日优惠！',
  
  q14: '如何删除我的账户？',
  a14: '要删除您的账户和所有相关数据，请联系我们的支持团队：support@makantak.com',
  a14Note: '注意：删除您的账户将删除您所有的虚拟货币余额和推荐历史记录。',
  
  q15: '我可以将我的虚拟货币转让给其他人吗？',
  a15: '不可以，虚拟货币不可转让，只能由赚取它的账户持有人使用。',
  
  q16: '如果二维码扫描器不工作怎么办？',
  a16: '如果二维码扫描器有问题，工作人员可以手动输入您的推荐码。您的代码显示在仪表板上二维码下方。',
};

export const about = {
  title: '关于MakanTak',
  subtitle: '通过推荐奖励革新餐厅会员计划',
  backToHome: '返回首页',
  
  missionTitle: '我们的使命',
  missionText: '通过双赢的推荐系统赋能餐厅和顾客，奖励分享，建立社区，让每个人的外出就餐更实惠。',
  
  whatWeDoTitle: '我们的服务',
  whatWeDoPara1: 'MakanTak是马来西亚首个专为餐厅设计的推荐奖励平台。我们帮助餐厅自然增长客户群，同时奖励忠实顾客分享推荐。',
  whatWeDoPara2: '与仅奖励个人购买的传统忠诚度计划不同，MakanTak创造了一个网络效应，让每个人都受益。当您分享推荐码并且您的朋友在餐厅用餐时，您会赚取虚拟货币。当他们的朋友用餐时，您再次赚取 - 最多3级！',
  
  coreValuesTitle: '我们的核心价值观',
  transparencyTitle: '透明度',
  transparencyDesc: '明确的规则、可见的收入和诚实的沟通。您始终确切知道您赚了多少以及何时过期。',
  communityTitle: '社区',
  communityDesc: '通过食物建立联系。每次推荐都加强社区并帮助当地餐厅蓬勃发展。',
  growthTitle: '增长',
  growthDesc: '对每个人都是双赢。餐厅有机地获得客户，客户在分享美食体验的同时省钱。',
  simplicityTitle: '简单',
  simplicityDesc: '每个人都易于使用。分享代码，赚取奖励，兑换折扣。没有复杂的规则或隐藏条款。',
  
  howItWorksTitle: '如何运作',
  step1Title: '注册并获取您的代码',
  step1Desc: '创建您的免费账户，立即获得唯一的推荐码和二维码。',
  step2Title: '与朋友分享',
  step2Desc: '通过WhatsApp、Facebook或任何消息应用分享您的代码。您的朋友首次访问可享受5%折扣！',
  step3Title: '自动赚取',
  step3Desc: '当您的推荐用餐时，您会自动赚取其账单的1%作为虚拟货币 - 最多3级！',
  step4Title: '兑换并节省',
  step4Desc: '使用您的虚拟货币在下一餐获得最多20%的折扣。出示您的二维码，立即节省！',
  
  forRestaurantsTitle: '为餐厅老板',
  forRestaurantsPara: 'MakanTak帮助您以传统营销成本的一小部分获得新客户。您不是在广告上花钱，而是奖励带来朋友的客户。',
  forRestaurantsPoint1: '通过口碑营销实现有机增长',
  forRestaurantsPoint2: '实时分析仪表板跟踪性能',
  forRestaurantsPoint3: '自动折扣计算和虚拟货币管理',
  forRestaurantsPoint4: '客户洞察和细分工具',
  partnerWithUs: '与我们合作',
  
  questionsTitle: '有问题或反馈？',
  questionsDesc: '我们很想听到您的声音！无论您是客户还是餐厅老板，请与我们联系。',
  viewFAQ: '查看常见问题',
  contactUs: '联系我们',
};

export const contact = {
  title: '联系我们',
  subtitle: '我们在这里为您服务！如有任何问题或反馈，请与我们联系。',
  backToHome: '返回首页',
  
  emailSupportTitle: '电子邮件支持',
  emailSupportDesc: '一般咨询和支持',
  emailSupportAddress: 'support@makantak.com',
  
  businessInquiriesTitle: '商务咨询',
  businessInquiriesDesc: '餐厅合作与商务洽谈',
  businessInquiriesAddress: 'support@makantak.com',
  
  sendMessageTitle: '给我们发送消息',
  nameLabel: '您的姓名',
  namePlaceholder: '张三',
  emailLabel: '电子邮件地址',
  emailPlaceholder: 'zhang@example.com',
  subjectLabel: '主题',
  subjectPlaceholder: '选择主题',
  subjectGeneral: '一般咨询',
  subjectSupport: '技术支持',
  subjectAccount: '账户问题',
  subjectPartnership: '餐厅合作伙伴',
  subjectFeedback: '反馈',
  subjectOther: '其他',
  messageLabel: '消息',
  messagePlaceholder: '告诉我们如何帮助您...',
  sendButton: '发送消息',
  sending: '发送中...',
  
  noteTitle: '注意：',
  noteText: '我们通常在工作日的24-48小时内回复。如有紧急事项，请致电我们的支持热线。',
  
  quickLinksTitle: '在联系我们之前，您可能会在这里找到答案：',
  faqTitle: '常见问题',
  faqDesc: '常见问题',
  aboutTitle: '关于我们',
  aboutDesc: '了解更多关于MakanTak',
  privacyTitle: '隐私政策',
  privacyDesc: '我们如何保护您的数据',
  
  messageSent: '消息发送成功！我们会尽快与您联系。',
  messageFailed: '发送消息失败。请重试或直接通过电子邮件联系我们。',
  fillAllFields: '请填写所有字段',
};
